/* eslint-disable max-len */
import React from 'react';

const Facebook = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7444 2.20418C12.5565 2.19688 13.3682 2.2013 14.1802 2.20162C14.1834 3.05825 14.1837 3.9152 14.1799 4.77179C13.6551 4.77086 13.1299 4.77307 12.6052 4.77086C12.2724 4.75013 11.9307 5.00238 11.8702 5.33226C11.8622 5.90545 11.8673 6.47896 11.8676 7.05218C12.6373 7.05535 13.407 7.05122 14.1767 7.05411C14.1203 7.88331 14.0174 8.70874 13.8968 9.53096C13.2169 9.53734 12.5367 9.53032 11.8568 9.53449C11.8508 11.9801 11.86 14.4258 11.8521 16.8715C10.8423 16.8756 9.83184 16.8695 8.82206 16.8743C8.80293 14.4283 8.82362 11.9811 8.81155 9.53481C8.31889 9.52968 7.82595 9.53834 7.33333 9.53068C7.33522 8.70845 7.33397 7.88627 7.33425 7.06433C7.82656 7.05831 8.31921 7.06561 8.81155 7.06084C8.82651 6.26152 8.79655 5.46127 8.82715 4.66262C8.87652 4.03013 9.11757 3.3929 9.59046 2.95602C10.1627 2.41115 10.9766 2.22712 11.7444 2.20418Z"
      fill="black"
    />
  </svg>
);

export default Facebook;
